import React from 'react'
import { useSelector } from 'react-redux'
import Loader from './Loaders/Loader'

function NonAuthContainer(props){
    const sessionStatus = useSelector(state => state.session.status)
    const siteStatus = useSelector(state => state.site.status)
    
    return <Loader type='spin' color='#000000' isLoading={(sessionStatus === "loading" || siteStatus === "initialLoading")}>
        {props.children}
    </Loader>

}

export default NonAuthContainer